// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flow-around{overflow:visible}.float-right{margin-left:20px;float:right}", "",{"version":3,"sources":["webpack://./components/header/help-modal.scss"],"names":[],"mappings":"AAAA,aACE,gBAAA,CAGF,aACE,gBAAA,CACA,WAAA","sourcesContent":[".flow-around {\r\n  overflow: visible;\r\n}\r\n\r\n.float-right {\r\n  margin-left: 20px;\r\n  float: right;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
